"use client"

import { leadership } from "../content/leadership"
import { useT } from "../lib/router"
import { Container, Eyebrow, Icon } from "./ui"
import styles from "./ceo-message.module.css"

export function CEOMessage() {
  const t = useT()

  return (
    <section id="ceo-message" aria-labelledby="ceo-message-heading" className="border-t border-line bg-white py-16 md:py-24">
      <Container>
        <div className="grid items-start gap-12 lg:grid-cols-12 lg:gap-16">
          <div className={`${styles.profile} mx-auto w-full max-w-[448px] lg:col-span-5 lg:mx-0`}>
            <div className={styles.frame}>
              <div className={styles.portrait}>
                <img
                  src="/img/orkest_ceo_eslam_mohamed.webp"
                  width={980}
                  height={1225}
                  alt={t(leadership.name)}
                  loading="lazy"
                  decoding="async"
                  className={styles.image}
                />
                <div aria-hidden="true" className={styles.overlay} />
                <svg aria-hidden="true" focusable="false" className={styles.track} viewBox="0 0 400 500" fill="none">
                  <path d="M-24 354H24C46 354 64 372 64 394V420C64 442 82 460 104 460H424" />
                </svg>
                <svg aria-hidden="true" focusable="false" className={styles.pulse} viewBox="0 0 400 500" fill="none">
                  <path pathLength={1} d="M-24 354H24C46 354 64 372 64 394V420C64 442 82 460 104 460H424" />
                </svg>
              </div>
            </div>
            <div className="mt-6 px-4 md:px-6">
              <p className="text-2xl font-medium text-ink">{t(leadership.name)}</p>
              <p className="mt-1 text-base font-medium text-blue">
                {t(leadership.role)} · {t({ en: "Orkest", ar: "أوركست" })}
              </p>
              <p className="mt-4 text-base leading-7 text-slate">{t(leadership.bio)}</p>
              <a
                href={leadership.profileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex min-h-11 items-center gap-2 rounded-r8 text-base font-medium text-blue underline underline-offset-4 hover:text-ink"
              >
                {t({ en: "More about Eslam", ar: "تعرّف على إسلام" })}
                <Icon name="arrow" flip className="size-5" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pt-4">
            <Eyebrow>{t({ en: "A message from our CEO", ar: "رسالة المدير التنفيذي" })}</Eyebrow>
            <h2 id="ceo-message-heading" className="brand-h2 mt-6 max-w-2xl font-medium text-ink">
              {t(leadership.heading)}
            </h2>
            <div className="mt-8 space-y-5 text-lg leading-8 text-slate">
              {leadership.message.map((paragraph, index) => (
                <p key={paragraph.en} className={index === 0 ? "text-ink" : undefined}>
                  {"emphasis" in paragraph && paragraph.emphasis ? (
                    <strong className="font-semibold text-ink">{t(paragraph)}</strong>
                  ) : (
                    t(paragraph)
                  )}
                </p>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}
